function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 1
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 1
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 19,
  cy: 5,
  r: 1
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 12,
  r: 1
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 1
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 19,
  cy: 12,
  r: 1
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 19,
  r: 1
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 19,
  r: 1
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 1
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/circles-grid.0f4d3468.svg";
export { SvgComponent as ReactComponent };